import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isAudiExclusiveEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('audiExclusive'),
)

export default isAudiExclusiveEnabledSelector
